var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmaill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7953 26H2.64393C1.94271 26 1.27022 25.7214 0.774388 25.2256C0.278556 24.7298 0 24.0573 0 23.3561V8.87926C0.0219757 8.44227 0.150412 8.01728 0.374131 7.64127C0.597849 7.26526 0.910072 6.94961 1.28363 6.72181L11.8593 0.376389C12.2701 0.130095 12.74 0 13.219 0C13.6979 0 14.1679 0.130095 14.5786 0.376389L25.1543 6.72181C25.9488 7.20168 26.4366 8.06096 26.4393 8.98898V23.3561C26.4393 24.0573 26.1607 24.7298 25.6649 25.2256C25.169 25.7214 24.4965 26 23.7953 26ZM2.64393 9.96194V23.3561H23.7953V9.96194L13.2196 17.012L2.64393 9.96194ZM13.2196 2.64356L4.38363 7.94463L13.2196 13.8353L22.0543 7.94463L13.2196 2.64356Z",
    fill: "#F0EDE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmaill);
export default __webpack_public_path__ + "static/media/Emaill.322d1b167d2fb6111d17ce3a408c9870.svg";
export { ForwardRef as ReactComponent };